import React, { Component } from 'react';
import { Row, Col, Accordion } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import CardGroup from 'react-bootstrap/CardGroup'
import { CustomToggle } from './custom/CustomToggle'

import Carousel from 'react-multi-carousel';
import { Footer } from './Footer';


export class AboutSite extends Component {
    static displayName = AboutSite.name;

    render() {
        return (
            <div>
                <div className="AboutUsMainDiv">

                    <div className="accardionPadding boldHeade" style={{
                        bottom: '0'
                    }}>
                        საიტის შესახებ
                 </div>
                    <div className="accardionPadding">
                        თქვენ ესტუმრეთ კულტურული მემკვიდრეობის გის-პორტალს, რომელიც წარმოადგენს საქართველოს კულტურული მემკვიდრეობის ერთიან მონაცემთა ბაზას ინტერაქტიული რუკით. გის-პორტალზე  განთავსებულია ინფორმაცია, ფოტოებით, აღწერილობებითა და ზუსტი მდებარეობით თითოეულ კულტურული მემკვიდრეობის ძეგლზე/ობიექტზე, მათ დაცვით ზონებზე, სამუზეუმო კოლექციებზე, მუზეუმებზე, მუზეუმ-ნაკრძალებზე, კედლის მხატვრობებზე, ქვაზე კვეთილობებზე, ქმედებებსა და დოკუმენტაციაზე. ჩვენი მიზანია გის-პორტალის საშუალებით წარმოვაჩინოთ და პოპულარიზაცია გავუწიოთ საქართველოს კულტურულ მემკვიდრეობას და შევქმნათ სახელმწიფო უწყებებთან და საზოგადოებასთან უწყვეტი კომუნიკაციის ინსტრუმენტი, რათა განვახორციელოთ კულტურული მემკვიდრეობის ძეგლების/ობიექტების გამოვლენა, ფიქსაცია, მონიტორინგი და გეგმაზომიერი კვლევა.
                        <p />
                        <p />
                    საქართველოს კულტურული მემკვიდრეობის დაცვის ეროვნული სააგენტოს საინფორმაციო სისტემების სამსახურის თანამშრომლები, რომლებიც  ანხორციელებენ კულტურული მემკვიდრეობის მონაცემთა მართვის გეოსაინფორმაციო სისტემის და გის პორტალის  განვითარებას და ადმინისტრირებას:
                        </div>

                    <CardGroup className="accardionPadding aboutSiteCardGroup">
                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/leila.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">ლეილა თუმანიშვილი</div>
                                <Card.Text className="aboutText">
                                    იდეის ავტორი, პროექტის ხელმძღვანელი, სისტემის და გის პორტალის ადმინისტრატორი, სისტემის მომხმარებელთა ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>
                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/giorgiK.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">გიორგი ხაბურზანია</div>
                                <Card.Text className="aboutText">
                                    სისტემის და გის პორტალის არქიტექტორი განვითარების მიმართულებით, პროექტის ხელმძღვანელი, სისტემის მომხმარებელთა ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>
                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/tengiz.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">თენგიზ ჩოლოყაშვილი</div>
                                <Card.Text className="aboutText">
                                    მთავარი IT სპეციალისტი, საცავის მონაცემთა ბაზის და სერვერების ადმინისტრატორი, პროექტის თანახელმძღვანელი
                                        </Card.Text>
                            </Card.Body>
                        </Card>


                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/irina.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">ირინე წულაძე</div>
                                <Card.Text className="aboutText">
                                    სისტემის და გის პორტალის ადმინისტრატორი, გის მონაცემების და სისტემის მომხმარებელთა ტრეინინგების მენეჯერი, სისტემის მომხმარებელთა  ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>
                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/giorgiB.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">გიორგი ბურჯანაძე</div>
                                <Card.Text className="aboutText">
                                    სისტემის და გის პორტალის ადმინისტრატორი, გის მონაცემების მენეჯერი და სისტემის მომხმარებელთა ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/revaz.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">რევაზ ვადაჭკორია</div>
                                <Card.Text className="aboutText">
                                    სისტემის და გის პორტალის ადმინისტრატორი, გის მონაცემების მენეჯერი და სისტემის მომხმარებელთა ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>

                    </CardGroup>

                    <Carousel
                        //additionalTransfrom={0}
                        // slidesToSlide={1}

                        //  centerMode={true}
                        focusOnSelect={true}
                        // partialVisible
                        className="aboutSiteCaruselNew"
                        arrows={false}
                        //  containerClass="container"

                        //itemClass="aboutSiteCaruselItem"
                        //   keyBoardControl
                        //minimumTouchDrag={50}

                        //customTransition="all .3"
                        //  transitionDuration={300}

                        renderButtonGroupOutside={false}
                        partialVisbile
                        //  removeArrowOnDeviceType={["mobile", "tablet"]}
                        responsive={{
                            desktop: {
                                breakpoint: { max: 1024, min: 444 },
                                items: 3,
                                paritialVisibilityGutter: 35
                            },
                            tablet: {
                                breakpoint: { max: 444, min: 394 },
                                items: 1,
                                paritialVisibilityGutter: 145
                            },
                            mobile: {
                                breakpoint: { max: 394, min: 0 },
                                items: 1,
                                paritialVisibilityGutter: 150
                            }
                        }}
                    //  sliderClass=""

                    >
                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/leila.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">ლეილა თუმანიშვილი</div>
                                <Card.Text className="aboutText">
                                    იდეის ავტორი, პროექტის ხელმძღვანელი, სისტემის და გის პორტალის ადმინისტრატორი, სისტემის მომხმარებელთა ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>



                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/giorgiK.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">გიორგი ხაბურზანია</div>
                                <Card.Text className="aboutText">
                                    სისტემის და გის პორტალის არქიტექტორი განვითარების მიმართულებით, პროექტის ხელმძღვანელი, სისტემის მომხმარებელთა ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/tengiz.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">თენგიზ ჩოლოყაშვილი</div>
                                <Card.Text className="aboutText">
                                    მთავარი IT სპეციალისტი, საცავის მონაცემთა ბაზის და სერვერების ადმინისტრატორი, პროექტის თანახელმძღვანელი
                                        </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/irina.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">ირინე წულაძე</div>
                                <Card.Text className="aboutText">
                                    სისტემის და გის პორტალის ადმინისტრატორი, გის მონაცემების და სისტემის მომხმარებელთა ტრეინინგების მენეჯერი, სისტემის მომხმარებელთა  ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>
                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/giorgiB.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">გიორგი ბურჯანაძე</div>
                                <Card.Text className="aboutText">
                                    სისტემის და გის პორტალის ადმინისტრატორი, გის მონაცემების მენეჯერი და სისტემის მომხმარებელთა ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>
                        <Card className="aboutCard">
                            <div className="aboutCardImgDiv">
                                <img alt="" variant="top" src="/images/revaz.jpg" className="aboutCardImg" />
                            </div>
                            <Card.Body>
                                <div className="aboutTextHeader">რევაზ ვადაჭკორია</div>
                                <Card.Text className="aboutText">
                                    სისტემის და გის პორტალის ადმინისტრატორი, გის მონაცემების მენეჯერი და სისტემის მომხმარებელთა ტრენერი
                                        </Card.Text>
                            </Card.Body>
                        </Card>
                    </Carousel>

                    <Row className="accardionPadding">
                        <Accordion defaultActiveKey="0">
                            <Card>
                                <Card.Header className="TogglePanelHeader aboutUsRowPadding">
                                    <CustomToggle eventKey="1">
                                        რას წარმოადგენს კულტურული მემკვიდრეობის გის პორტალი?
                                </CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body style={{ padding: '20px' }}>
                                        კულტურული მემკვიდრეობის  გის პორტალი წარმოადგენს ერთიანი, კომპლექსური სისტემის შემადგენელ ნაწილს და მოიცავს ინფორმაციას ქვეყანაში არსებულ კულტურული მემკვიდრეობის უძრავ ძეგლებზე/ობიექტებზე, მასთან დაკავშირებულ დამცავ ზონებზე, კედლის მხატვრობაზე, ქვაზე კვეთილობაზე და ამასთანავე მოძრავ კულტურულ ფასეულობებზე, რომლებიც განთავსებულნი არიან სხვადასხვა მუზეუმებში და მუზეუმ-ნაკრძალებში.
                                        <p />
                                        კულტურული მემკვიდრეობის მონაცემთა მართვის გეოსაინფორმაციო სისტემა ჩამოყალიბდა, როგორც კულტურული მემკვიდრეობის რესურსების ადმინისტრირების, მონიტორინგისა და კვლევის მთავარი ინსტრუმენტი. გის პორტალზე განთავსებულია კულტურული მემკვიდრეობის მონაცემთა მართვის გეოსაინფორმაციო სისტემის  შექმნის პერიოდისთვის არსებული მონაცემთა ბაზები, ასევე საქართველოს კულტურული მემკვიდრეობის დაცვის ეროვნულ საგენტოში არსებული სხვადასხვა ფორმატის ფაილების და პროექტების მონაცემები.
                                        <p />
                                        სისტემა საშუალებას იძლევა მსოფლიოს ნებისმიერი კუთხიდან ინტერაქტიულ რეჟიმში შეივსოს, განახლდეს  და მოძიებულ იქნას ინფორმაცია კულტურული მემკვიდრეობის ძეგლების/ობიექტების შესახებ.
                                        </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Row>

                    <Row className="accardionPadding">
                        <Accordion defaultActiveKey="0">
                            <Card>
                                <Card.Header className="TogglePanelHeader aboutUsRowPadding">
                                    <CustomToggle eventKey="1">გის პორტალის შექმნის ისტორია</CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body style={{ padding: '20px' }}>
                                        გის პორტალი შეიქმნა საქართველოს კულტურული მემკვიდრეობის დაცვის ეროვნულ სააგენტოსა და ნორვეგიის კულტურული მემკვიდრეობის დირექტორატს RiksAntikvaren-ს შორის ურთიერთთანამშრომლობის შეთანხმების საფუძველზე დაგეგმილი მრავალწლიანი პროექტის, „საქართველოს კულტურული მემკვიდრეობის მონაცემთა მართვის გეოსაინფორმაციო სისტემის და გის პორტალის შექმნა“(2013-2018 წწ), ფარგლებში. პროექტის იდეა გულისხმობდა გეოსაინფორმაციო სისტემაზე დაფუძნებული ერთიანი, კომპლექსური მონაცემთა ბაზის განვითარებას კულტურული მემკვიდრეობის სფეროში და შეთავაზებული იყო პროექტში მონაწილე  ქართული მხარის მიერ. სისტემა წარმოადგენს კულტურული მემკვიდრეობის მართვის ინტეგრირებულ ინსტრუმენტს, რომლის დანიშნულებაა მოპოვებული ინფორმაციის გეორეფერენსირებული და სტრუქტურირებული ფორმით განთავსება მონაცემთა ბაზაში და მისი მართვა, ცენტრალურ და რეგიონულ მართვის სტრუქტურებსა და მასთან დაკავშირებულ უწყებებთან ინფორმაციის გაცვლის სისტემის შექმნა და ფართო საზოგადოებისთვის ამ მონაცემებთან წვდომის უზრუნველყოფა.
                                        <p />
                                        <div style={{ fontFamily: 'HelveticaBold' }}>
                                            პროექტი სრულად დაფინანსებულია ნორვეგიის საგარეო საქმეთა სამინისტროს მიერ.
                                            </div>
                                        <p />
                                        <div style={{ fontFamily: 'HelveticaBold' }}>
                                            პროექტზე მუშაობდნენ საქართველოს კულტურული მემკვიდრეობის დაცვის ეროვნული სააგენტოს საინფორმაციო სისტემების სამსახური და შპს „დისტანციური ზონდირებისა და გეოინფორმაციული სისტემების საკონსულტაციო ცენტრი გეოგრაფიკი“.
                                            </div>
                                        <p />

                                            პროექტს საფუძველი ჩაეყარა ჯერ კიდევ 2009 წელს, როდესაც საქართველოს კულტურული მემკვიდრეობის ეროვნულ სააგენტოსა და ნორვეგიის კულტურული მემკვიდრეობის დირექტორატს შორის ხელი მოეწერა თანამშრომლობის ხელშეკრულებას. ამ ეტაპიდან კულტურული მემკვიდრეობის გეოინფორმაციული სისტემების (GIS) განვითარება საქართველოში ერთ-ერთ უმთავრეს პრიორიტეტად განისაზღვრა კულტურული მემკვიდრეობის პრაქტიკულ მართვაზე პასუხისმგებელი ინსტიტუციის მიერ.
                                    <p />
                                    2010-წლიდან, პირველი საგრანტო ხელშეკრულების ფარგლებში განხორციელება დაიწყო გეოსაინფორმაციო სისტემების განვითარების წინმსწრებმა პროექტმა „საქართველოს კულტურული მემკვიდრეობის არქივის დიგიტალიზაცია“. პარალელურად, ნორვეგიული მხარე გეგმაზომიერად მუშაობდა ქართველ სპეციალისტებთან გეოსაინფორმაციო სისტემების ნორვეგიული მოდელის შესწავლის და პროექტის ახალი ეტაპის მომზადების მიმართულებით.
                                    <p />
                                    გის პორტალზე მუშაობის პროცესში გაანალიზებულ იქნა ევროპის მოწინავე ქვეყნების, მათ შორის დანიის, ბრიტანეთის, ა.შ.შ-ს და სხვა  ქვეყნების, გამოცდილება მსგავსი მიმართულებით, გაიმართა არაერთი სამუშაო ვიზიტი და კონსულტაცია ნორვეგიელ ექსპერტებთან.
                                     <p />
                                    საქართველოს კულტურული მემკვიდრეობის დაცვის ეროვნული სააგენტოს სამსახურების წარმომადგენლები მიმართულებების მიხედვით, რომლებიც თანამშრომლობდნენ პროექტთან მისი განვითარების სხვადასხვა ეტაპზე:
                                    <Row>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">ნიკოლოზ ანთიძე</Col>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">დავით ლომიტაშვილი</Col>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">ლალი მაძღარაშვილი</Col>
                                        </Row>
                                        <Row>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">მანანა ვარძელაშვილი</Col>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">რუსუდან მირზიკაშვილი</Col>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">თეა ონიანი</Col>
                                        </Row>
                                        <Row>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">გიორგი გაგოშიძე</Col>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">ირმა დოლიძე</Col>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">ირინა საბაშვილი</Col>
                                        </Row>
                                        <p style={{ borderBottom: '1px solid #ECECEC' }} />
                                    კულტურული მემკვიდრეობის სხვადასხვა დარგის მოწვეული ექსპერტები, რომლებიც საინფორმაციო სისტემების სამსახურთან კოორდინაციით მუშაობდნენ კულტურული მემკვიდრეობის მონაცემთა მართვის გეოსაინფორმაციო სისტემის პროგრამული ველების ჩამონათვლის შექმნაზე:
                                    <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">კონსტანტინე ამირეჯიბი</div>
                                                        <Card.Text>
                                                            ურბანისტი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">დიმიტრი თუმანიშვილი</div>
                                                        <Card.Text>
                                                            ხელოვნებათმცოდნე
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ნინო კიტოვანი</div>
                                                        <Card.Text >
                                                            ექსპერტი მოძრავი ობიექტებისა და მუზეუმების დარგში
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">გოდერძი ნარიმანიშვილი</div>
                                                        <Card.Text >
                                                            არქეოლოგი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ზვიად შერაზადიშვილი</div>
                                                        <Card.Text >
                                                            არქეოლოგი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ციცინო ჩაჩხუნაშვილი</div>
                                                        <Card.Text >
                                                            ხელოვნების ისტორიკოსი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">მარიამ ლომიძე</div>
                                                        <Card.Text >
                                                            არქიტექტორი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">მარინა თუმანიშვილი</div>
                                                        <Card.Text >
                                                            ურბანისტი
                                                        </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <p style={{ borderBottom: '1px solid #ECECEC', paddingTop: '10px' }} />
                                    გის და IT სპეციალისტები შპს ”გის და დზ საკონსულტაციო ცენტრ გეოგრაფიკი”- დან:
                                     <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">გიორგი გოცირიძე</div>
                                                        <Card.Text>
                                                            დირექტორი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">მამუკა ხურციძე</div>
                                                        <Card.Text>
                                                            გენერალური მენეჯერი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ნანა დიხამინჯია</div>
                                                        <Card.Text >
                                                            პროგრამისტი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">რევაზ ყენია</div>
                                                        <Card.Text >
                                                            გის ექსპერტი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ირინა ვართანოვი</div>
                                                        <Card.Text >
                                                            გის კომპლექსური მონაცემთა ბაზის მთავარი პროგრამისტი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">თეონა ქუჯოშვილი</div>
                                                        <Card.Text >
                                                            პროგრამისტი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>

                                        <p style={{ borderBottom: '1px solid #ECECEC', paddingTop: '10px' }} />
                                    კულტურული მემკვიდრეობის გის-პორტალის განახლების კუთხით მოწვეული UX დიზაინერები:
                                     <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">მარიამ ქობულაძე</div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ტატო ბექთაშაშვილი</div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <p style={{ borderBottom: '1px solid #ECECEC', paddingTop: '10px' }} />
                                    ნორვეგიელი ექსპერტები, რომლებიც იღებდნენ მონაწილეობას პროექტის განხორციელების პროცესში, მის განვითარებასა და კონსულტირებაში:
                                     <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="card-text">პროექტის კოორდინატორი</div>
                                                        <div className="aboutTextHeader">იორგენ ჰოლტენ იორგენსენი</div>
                                                        <Card.Text >
                                                            კულტურული მემკვიდრეობის დირექტორატის უფროსი მრჩეველი, საერთაშორისო ურთიერთობების მიმართულებით
                                                    </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">რაიდუნ ვეა</div>
                                                        <Card.Text >
                                                            კულტურული მემკვიდრეობის დირექტორატის საერთაშორისო ურთიერთობების დეპარტამენტის უფროსი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ჯოალ ბოაზი</div>
                                                        <Card.Text >
                                                            კულტურული მემკვიდრეობის დირექტორატის მრჩეველი კულტურული მემკვიდრეობის მონაცემების მიმართულებით, ასკელადენის ადმინისტრატორი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">კრისტერ ვინიე გიმსე</div>
                                                        <Card.Text >
                                                            კულტურული მემკვიდრეობის დირექტორატის მრჩეველი კულტურული მემკვიდრეობის მონაცემების მიმართულებით, რესურსებისა და განვითარების დეპარტამენტი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">სტიან ფინმარკი</div>
                                                        <Card.Text >
                                                            ნორვეგიის კულტურული მემკვიდრეობის დირექტორატის ასკელადენის ჯგუფის კოორდინატორი, მონაცემთა ბაზების და გის-ის მიმართულებით
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ესპენ ულებერგი</div>
                                                        <Card.Text >
                                                            ასკელადენის კოორდინაციის ჯგუფის ხელმძღვანელი ოსლოს უნივერსიტეტში, დიგიტალური დოკუმენტაციის მთავარი ინჟინერი, მონაცემთა ბაზების ადმინისტრატორი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4} className="paddingClass">
                                                <Card>
                                                    <Card.Body>
                                                        <div className="aboutTextHeader">ჰიულდა ბერნჰარდტი</div>
                                                        <Card.Text >
                                                            კულტურული მემკვიდრეობის დირექტორატის მრჩეველი კულტურული მემკვიდრეობის მონაცემების მიმართულებით, რესურსებისა და განვითარების დეპარტამენტი
                                                </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <p style={{ borderBottom: '1px solid #ECECEC', paddingTop: '10px' }} />
                                        დარგობრივი ინსტიტუციები, რომლებთან თანამშრომლობით გაანალიზდა მათ ხელთ არსებული ინფორმაციის სისტემატიზაციის ფორმები:
                                        <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">საქართველოს კულტურისა და ძეგლთა დაცვის სამინისტრო</Col>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">საქართველოს ეროვნული მუზეუმი</Col>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">საქართველოს იუსტიციის სამინისტროს საჯარო რეესტრის ეროვნული სააგენტო</Col>
                                        </Row>
                                        <Row style={{ paddingTop: '20px' }}>
                                            <Col md={4} style={{ fontFamily: 'HelveticaBold', padding: '20px' }} className="paddingClass">გიორგი ჩუბინაშვილის სახელობის ქართული ხელოვნების ისტორიისა და ძეგლთა დაცვის კვლევის ეროვნული ცენტრი</Col>
                                        </Row>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Row>

                    <Row className="accardionPadding">
                        <Accordion defaultActiveKey="0" >
                            <Card>
                                <Card.Header className="TogglePanelHeader aboutUsRowPadding">
                                    <CustomToggle eventKey="1">გის პორტალის მართვა</CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body style={{ padding: '20px' }}>
                                        კულტურული მემკვიდრეობის მონაცემთა მართვის გეოსაინფორმაციო სისტემის და გის პორტალის შექმნას, განვითარებას და მართვას ახორციელებს საქართველოს კულტურული მემკვიდრეობის დაცვის ეროვნული სააგენტოს საინფორმაციო სისტემების სამსახური - გის კომპლექსური მონაცემთა ბაზის მართვის ჯგუფი. ამავდროულად ჯგუფი არ არის პასუხისმგებელი პორტალზე განთავსებული ინფორმაციის შინაარსზე.
                                        </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Row>

                    <Row className="accardionPadding">
                        <Accordion defaultActiveKey="0">
                            <Card>
                                <Card.Header className="TogglePanelHeader aboutUsRowPadding">
                                    <CustomToggle eventKey="1">გის პორტალის შესაძლებლობები და მიზნები</CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body style={{ padding: '20px' }}>
                                        კულტურულ მემკვიდრეობასთან დაკავშირებული სივრცითი და ატრიბუტული მონაცემები წარმოადგენს მნიშვნელოვან მასალას კულტურული მემკვიდრეობის მკვლევარებისა და სხვადასხვა დარგის წარმომადგენლებისთვის. კულტურულ მემკვიდრეობის საბაზისო მონაცემების გამოქვეყნება გის პორტალზე საშუალებას მისცემს ფართო საზოგადოებას გაეცნოს, შეისწავლოს და გაანალიზოს ეს ინფორმაცია. გის პორტალი ხელს შეუწყობს არსებული მონაცემების დაზუსტებას, შევსებას და ახალი ობიექტების გამოვლენას, მახვილმასშტაბიანი სამშენებლო, მათ შორის ინფრასტრუქტურული და სხვა ტიპის, პროექტების წარმოებას, რომლებზეც მუშაობა შეუძლებელია კულტურული მემკვიდრეობის შესახებ ინფორმაციის გათვალისწინების გარეშე.
                                        <p />
                                        აღსანიშნავია, რომ საქართველოს ტერიტორიის უმეტესი ნაწილი ჯერ კიდევ საჭიროებს ინვენტარიზაციას და კულტურული მემკვიდრეობის ძეგლების ნუსხების შევსებას, რაც პირდაპირ არის დაკავშირებული გის პორტალზე ინფორმაციის მუდმივად განახლების პროცესთან.
                                        <p />
                                        გის პორტალის მეშვეობით დაინტერესებული პირი შეძლებს მიიღოს ინფორმაცია:
                                        <Row>
                                            <Col className="aboutCol">ძეგლების/ობიექტების ადგილმდებარეობაზე საქართველოს ერთიანი ელექტრონული რუკის საფუძველზე.</Col>
                                            <Col className="aboutCol">ძეგლის/ობიექტის სტატუსსა და კატეგორიაზე.</Col>
                                        </Row>
                                        <Row>
                                            <Col className="aboutCol">ძეგლის/ობიექტის არქიტექტურულ-მხატვრული სახის, პერიოდისა და ფიზიკური მდგომარეობის შესახებ.</Col>
                                            <Col className="aboutCol">ძეგლის ტერიტორიაზე და მის დამცავ ზონებზე.</Col>
                                        </Row>
                                        <Row>
                                            <Col className="aboutCol">ძეგლზე/ობიექტზე განხორციელებულ და მიმდინარე ქმედებებზე და სხვა.</Col>
                                        </Row>
                                        <p />
                                        <Row>
                                            <Col>
                                                <div style={{
                                                    backgroundColor: '#698E7F', borderRadius: '5px', width: '5px', position: 'absolute', height: '100%'
                                                }}></div>
                                                <div style={{ marginLeft: '30px' }}> ამასთან, პორტალის მეშვეობით ნებისმიერ, კულტურული მემკვიდრეობით დაინტერესებულ პირს ექნება საშუალება სააგენტოს მიაწოდოს ინფორმაცია კონკრეტული ძეგლებისა და ახლად გამოვლენილი კულტურული მემკვიდრეობის ობიექტების შესახებ.</div>
                                            </Col>
                                        </Row>
                                        {
                                            //<Row>
                                            //    <Col md={8}>
                                            //        <div >
                                            //            <div style={{
                                            //                backgroundColor: '#698E7F', borderRadius: '5px', width: '5px', position: 'absolute', height: '100%'
                                            //            }}></div>
                                            //            <div style={{ marginLeft: '30px' }}> ამასთან, პორტალის მეშვეობით ნებისმიერ, კულტურული მემკვიდრეობით დაინტერესებულ პირს ექნება საშუალება სააგენტოს მიაწოდოს ინფორმაცია კონკრეტული ძეგლებისა და ახლად გამოვლენილი კულტურული მემკვიდრეობის ობიექტების შესახებ.</div>
                                            //        </div>
                                            //    </Col>
                                            //    <Col md={4}>
                                            //        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                            //            <button className="OrangeButton MainButton">
                                            //                დაამატე მემკვიდრეობა
                                            //    </button>
                                            //        </div>

                                            //    </Col>
                                            //</Row>
                                        }
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Row>

                    <Row className="accardionPadding aboutUsFooter">
                        <Col md={6} style={{ paddingTop: '25px' }}>
                            პროექტი განხორციელდა საქართველოს კულტურული მემკვიდრეობის დაცვის ეროვნულ სააგენტოსა და ნორვეგიის კულტურული მემკვიდრეობის დირექტორატს -რიკსანტიკვარენს შორის თანამშრომლობის ფარგლებში და დაფინანსებულია ნორვეგიის საგარეო საქმეთა სამინისტროს მიერ.
                        </Col>
                        <Col md={6} style={{ textAlign: 'center', paddingTop: '25px' }}>
                            <a href="https://heritagesites.ge/ka" rel="noopener noreferrer" target="_blank"><img alt="" variant="top" src="/images/logo1.png" className="logoAboutImg" /></a>
                            <a href="https://www.riksantikvaren.no/" rel="noopener noreferrer" target="_blank"><img alt="" variant="top" src="/images/ra-logo.svg" className="logoAboutImg" /></a>
                        </Col>
                    </Row>
                </div>
                <Footer></Footer>
            </div>
        );
    }

}
